import { Injectable } from '@angular/core';
import { FirebaseObservableServiceFactory } from '@damofire/data-angular-commons';
import { ChangeTyped, SearchResult, WW_REPAIRS_COLLECTION } from '@damofire/data-commons';
import { map, Observable } from 'rxjs';
import { TypedDesQuery } from '../des.dto';
import { FirebaseWatsonObservableService } from '../firebase-watson-observable.service';
import { ObservableRepairService } from './repair-observable.service';
import { Repair } from './repair.dto';

@Injectable()
export class FirebaseObservableRepairService extends ObservableRepairService {
  private readonly firebaseWatsonObservableService: FirebaseWatsonObservableService<Repair>;

  constructor(private readonly firebaseObservableServiceFactory: FirebaseObservableServiceFactory) {
    super();
    this.firebaseWatsonObservableService = new FirebaseWatsonObservableService(firebaseObservableServiceFactory, WW_REPAIRS_COLLECTION);
  }

  observeById(division: string, id: string): Observable<ChangeTyped<Repair>> {
    return this.firebaseWatsonObservableService.observeDoc(id);
  }

  search(divisionId: string, sQuery: TypedDesQuery): Observable<SearchResult<Repair>> {
    return this.firebaseWatsonObservableService.search(divisionId, sQuery, this.SEARCH_FIELDS);
  }

  observeByAsset(divisionId: string, assetId: string): Observable<ChangeTyped<Repair>[]> {
    return this.firebaseWatsonObservableService.observeByWarehousePiped(
      divisionId,
      map((fromFirestore) => {
        return fromFirestore.filter((doc) => {
          return `${doc.upright._id}` === assetId;
        });
      }),
    );
  }

  observeByWarehouse(divisionId: string): Observable<ChangeTyped<Repair>[]> {
    return this.firebaseWatsonObservableService.observeByWarehousePiped(
      divisionId,
      map((fromFirestore) => fromFirestore),
    );
  }
}
